import {PATHS} from "../../../../routers/utils/Paths.links";
import type {TranslationKey} from "../../../../i18n/ua";

// Основні розділи сайту — однакові в навбарі (десктоп) і в бургер-меню (мобільні)
export interface INavItem {
    key: string,
    to: string,
    labelKey: TranslationKey,
    icon: JSX.Element,
    isActive: (pathname: string) => boolean,
}

const SHOP_PATHS: string[] = [PATHS.SHOP, PATHS.SHOPLITE, PATHS.SHOPTRIO];

export const NAV_ITEMS: INavItem[] = [
    {
        key: "shop",
        to: PATHS.SHOP,
        labelKey: "nav.shop",
        isActive: (p) => SHOP_PATHS.includes(p),
        icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M7 7V6a5 5 0 0110 0v1h2.2a1 1 0 011 .9l1 12A2 2 0 0119.2 22H4.8a2 2 0 01-2-2.1l1-12a1 1 0 011-.9H7zm2 0h6V6a3 3 0 00-6 0v1zm-1 3.5a1 1 0 100 2 1 1 0 000-2zm8 0a1 1 0 100 2 1 1 0 000-2z" />
            </svg>
        ),
    },
    {
        key: "leaders",
        to: PATHS.STATS,
        labelKey: "nav.leaders",
        isActive: (p) => p.startsWith(PATHS.STATS),
        icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M3 8l4.5 4L12 5l4.5 7L21 8l-2 11H5L3 8zm2.4 13h13.2v-1.6H5.4V21z" />
            </svg>
        ),
    },
    {
        key: "case",
        to: PATHS.CASE,
        labelKey: "nav.case",
        isActive: (p) => p.startsWith(PATHS.CASE),
        icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M12 2.2l9 5v9.6l-9 5-9-5V7.2l9-5zm0 2.3L5.6 8 12 11.6 18.4 8 12 4.5zM5 9.7v6l6 3.4v-6L5 9.7zm14 0l-6 3.4v6l6-3.4v-6z" />
            </svg>
        ),
    },
    {
        key: "giveaways",
        to: PATHS.GIVEAWAYS,
        labelKey: "nav.giveaways",
        isActive: (p) => p.startsWith(PATHS.GIVEAWAYS),
        icon: (
            <svg width="19" height="19" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M4 11h7v10H5a1 1 0 01-1-1zM13 11h7v9a1 1 0 01-1 1h-6z" />
                <path d="M3 8a1 1 0 011-1h7v3H3zM13 7h7a1 1 0 011 1v2h-8z" />
                <path d="M11.4 6.6C10 3.4 6.4 2.9 6.4 5.3c0 1.6 2.2 1.7 5 1.3zM12.6 6.6c1.4-3.2 5-3.7 5-1.3 0 1.6-2.2 1.7-5 1.3z" />
            </svg>
        ),
    },
];
